/**
 * Created by henian.xu on 2018/7/18.
 *
 */

import { Mb } from './Mb';

class Member extends Mb {
    constructor() {
        super();
        this.baseUrl += '/member';
    }

    data({
        userName,
        fullName,
        mobile,
        nickName,
        sex,
        idCardNo,
        registerTime,
        memberStatus,
        currentPage,
        pageSize,
    } = {}) {
        let registerBeginTime = null;
        let registerEndTime = null;
        if (registerTime != null && registerTime.length === 2) {
            [registerBeginTime, registerEndTime] = registerTime;
        }
        return super.get('/data', {
            userName,
            fullName,
            mobile,
            nickName,
            sex,
            idCardNo,
            memberStatus,
            registerBeginTime,
            registerEndTime,
            currentPage,
            pageSize,
        });
    }

    changeMemberLevel({ ids, memberLevelId }) {
        return super.post('/changeMemberLevel', {
            ids,
            memberLevelId,
        });
    }

    getDetail({ id }) {
        return super.get('/getMemberById', { id });
    }

    getMemberDetail2({ id }) {
        return super.get('/getMemberDetail2', { id });
    }

    editInfo({ id, mobile }) {
        return super.post('/editInfo', { id, mobile });
    }

    changeMemberAuthority({ id, memberAuthority }) {
        return super.post('/changeMemberAuthority', { id, memberAuthority });
    }
}

export default new Member();
export { Member };
